import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { api } from "../services/api";
import PageHeader from "./ui/PageHeader";
import LoadingState from "./ui/LoadingState";
import AlertBanner from "./ui/AlertBanner";

const Settings = () => {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingKey, setSavingKey] = useState(null);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => { loadSettings(); }, []);

  const loadSettings = async () => {
    setLoading(true);
    try { setSettings(await api.getSettings()); }
    catch (err) { setFeedback({ type: "danger", message: err.message }); }
    finally { setLoading(false); }
  };

  const handleSave = async (key) => {
    const setting = settings.find((s) => s.setting_key === key);
    if (!setting) return;
    setSavingKey(key);
    try {
      await api.updateSetting(key, setting.setting_value);
      setFeedback({ type: "success", message: `Saved "${key}"` });
    } catch (err) {
      setFeedback({ type: "danger", message: err.message });
    } finally {
      setSavingKey(null);
    }
  };

  const grouped = settings.reduce((acc, item) => {
    const g = item.setting_group || "general";
    if (!acc[g]) acc[g] = [];
    acc[g].push(item);
    return acc;
  }, {});

  if (loading) return <LoadingState message="Loading settings..." />;

  return (
    <div>
      <PageHeader title="Settings" subtitle="Application configuration for Indian market" />
      {feedback && <AlertBanner type={feedback.type} message={feedback.message} onClose={() => setFeedback(null)} />}

      {Object.entries(grouped).map(([group, items]) => (
        <div key={group} className="billr-card mb-4">
          <div className="billr-card-header"><h5 className="text-capitalize">{group}</h5></div>
          <div className="billr-card-body padded">
            {items.map((item) => (
              <Row key={item.setting_key} className="mb-3 align-items-center">
                <Col md={4}>
                  <div className="fw-semibold small">{item.setting_key}</div>
                  {item.description && <div className="text-muted small">{item.description}</div>}
                </Col>
                <Col md={6}>
                  <input className="billr-input" value={item.setting_value} onChange={(e) => setSettings((prev) => prev.map((s) => s.setting_key === item.setting_key ? { ...s, setting_value: e.target.value } : s))} />
                </Col>
                <Col md={2}>
                  <button className="btn-billr btn-billr-primary btn-billr-sm w-100" disabled={savingKey === item.setting_key} onClick={() => handleSave(item.setting_key)}>
                    {savingKey === item.setting_key ? "..." : "Save"}
                  </button>
                </Col>
              </Row>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Settings;
